import React from "react";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Link } from "@/components/common/Link";
import { ArrowRight, Crosshair } from "lucide-react";
export default function ArmenianPhotogrammetryHero() {
  return <section id="armenianphotogrammetryhero" className="relative w-full overflow-hidden bg-background py-16 md:py-24 lg:py-32">
      {/* Background decoration */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[600px] bg-chart-3/5 blur-[120px] pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          
          {/* Text Content */}
          <div className="flex-1 space-y-8 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 border border-[#00d2ff] rounded-full px-4 py-1.5 text-white font-semibold text-xs tracking-widest uppercase mb-6 w-max bg-[#22c55e]/10">   
              <Crosshair className="lucide lucide-crosshair w-4 h-4 !text-[rgba(0,210,255,1)]" />
              <span>Բարձր Ճշտության Տվյալներ</span>
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold leading-tight tracking-tight text-foreground">
              Ֆոտոգրամետրիական աշխատանքներ
            </h1>
            
            <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto lg:mx-0 font-sans leading-relaxed">
              Գեոկոսմոս ՓԲԸ-ն առաջարկում է առաջադեմ ֆոտոգրամետրիական լուծումներ՝ 
              օգտագործելով արբանյակային և օդային գերճշգրիտ տվյալներ: Մեր ինժեներական 
              մոտեցումը ապահովում է հուսալի և մանրամասն տարածական մոդելավորում ձեր 
              ռազմավարական նախագծերի համար.
            </p>
            
            
          </div>

          {/* Image/Workstation Element */}
          <div className="flex-1 w-full max-w-2xl lg:max-w-none mx-auto">
            <div className="relative group">
              {/* Outer decorative shadow/glow */}
              <div className="absolute -inset-1 bg-gradient-to-tr from-chart-3/40 to-transparent rounded-2xl blur-md opacity-70 group-hover:opacity-100 transition-opacity duration-500" />
              
              <div className="relative rounded-2xl overflow-hidden border border-chart-3/30 bg-card/40 backdrop-blur-xl p-2 shadow-2xl">
                <div className="relative rounded-xl overflow-hidden border border-border/50 bg-muted">
                  <AspectRatio ratio={4 / 3}>
                    <img alt="Ֆոտոգրամետրիական աշխատանքային միջավայր" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666312/img/multispectral_analysis_workstation.png" />
                    {/* Subtle color overlay */}
                    <div className="absolute inset-0 bg-blue-900/10 mix-blend-overlay pointer-events-none" />
                    
                    {/* Decorative UI elements (little squares and text removed) */}
                    <div className="absolute top-4 left-4 flex gap-2">
                      <div className="w-2 h-2 rounded-sm bg-chart-3 animate-pulse" />
                      <div className="w-2 h-2 rounded-sm bg-chart-3/50" />
                      <div className="w-2 h-2 rounded-sm bg-chart-3/50" />
                    </div>
                  </AspectRatio>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}